import {useState} from "react";
import Modal from "./modal";
import TemplateInfo from "../templateInfo";

export default (props) => {
    const [showModal, setShowModal] = useState(false);
    const edit = (event) => {
        event.preventDefault();
        setShowModal(!showModal);
    };
    const save = (event) => {
        event.preventDefault();
        props.sumbitJobDetails(false).then(success => {
            if (success) {
                setShowModal(!showModal);
            }
        });
    };
    return (
        <div className="card h-100">
        {
            showModal && <Modal label={"Template Info"} showHide={edit} saveFunction={save}>
                <TemplateInfo errors={props.errors}/>
            </Modal>
        }
       <div className="card-header">
                    <b><h5 className="mb-0">Template Info</h5></b>
                    {
                        props.editMode && <a className="edit-icon" id="btnShowModel_Job_Type" href="#" onClick={edit}>
                            <i className="fe fe-edit" title="Edit Template"></i>
                        </a>
                    }
                </div>
        <div className="card-body ">
            <div className="form-group">
                {props?.jobTemplateName !== 'Select' &&
                    <div className="col-lg-4 col-md-4">
                        <label className="form-label"> Template</label>
                        <label
                            htmlFor="Location Name">{props?.jobTemplateName === 'Select' ? '' : props?.jobTemplateName}</label>
                    </div>
                }
            </div>
        </div>
    </div>
    )
}
